const getChannelInfoUrl = 'https://obojgv62cuemi3iyhuyg2kweyq0igipu.lambda-url.us-east-1.on.aws';
const getPublishedGamesUrl = 'https://5dy3cuphgnax4shfcb4zxy5eu40czwef.lambda-url.us-east-1.on.aws';

const getChannelInfo = async (channelId) => {
  const url = `${getChannelInfoUrl}/${channelId}`;
  const response = await fetch(url);
  const json = await response.json();
  if (!json) return {};
  return json;
}

const getPublishedGames = async () => {
  const url = `${getPublishedGamesUrl}/`;
  const response = await fetch(url);
  const json = await response.json();
  if (!json) return {};
  return json;
}

export {
  getChannelInfo,
  getPublishedGames,
}
